import { EventType } from './types';
var nextId = 0;
function addLog(logs, type, message) {
    var entry = {
        id: nextId++,
        timestamp: new Date(),
        type: type,
        message: message,
    };
    var newLogs = logs.concat([entry]);
    if (newLogs.length > 100) {
        newLogs.shift();
    }
    return newLogs;
}
export function eventLogReducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case 'SEND_UPDATE':
            return addLog(state, EventType.OUTGOING, action.message.type + ': ' + JSON.stringify(action.message.payload));
        case 'UPDATE_RECEIVED':
            return addLog(state, EventType.INCOMING, action.message.type + ': ' + JSON.stringify(action.message.payload));
    }
    return state;
}



//////////////////
// WEBPACK FOOTER
// ./src/components/EventLog/reducers.ts
// module id = 1825
// module chunks = 0